export { type GraphemeHkData, graphemeHkDataTable } from "#grapheme-hk-data-table";
